import { AppRoutes } from "@/routes/config";
import { TBaseSessionState, useListSessionStorage } from "@/hooks/useListSessionStorage";

const INFORMATION_LIST_SESSION_KEY = "information_list_state";

export type TInformationListSessionState = TBaseSessionState & {
  selectedKeys?: string[];
};

export const useInformationListSessionStorage = () => {
  return useListSessionStorage<TInformationListSessionState>({
    sessionKey: INFORMATION_LIST_SESSION_KEY,
    defaultBackUrl: AppRoutes.information,
  });
};
